import { PageListProps, PageListTemplate } from '@templates';

interface OfferLine {
  line: string;
  field: string;
  message: string;
}

interface ErrorsOfferBulkTableProps {
  data: OfferLine[];
  isLoading: boolean;
}

export const ErrorsOfferBulkTable = ({
  data,
  isLoading,
}: ErrorsOfferBulkTableProps) => {
  const headerColumns: PageListProps<OfferLine>['columns'] = [
    {
      key: 'line',
      title: 'Linha',
      dataIndex: 'line',
      width: '80px',
      sorter: false,
    },
    {
      key: 'message',
      title: 'Mensagem',
      dataIndex: 'message',
      sorter: false,
    },
  ];

  return (
    <PageListTemplate
      columns={headerColumns}
      data={{ rows: data }}
      loading={isLoading}
      hidePagination
    />
  );
};
